<h5>
	<strong>{{ 'misc.developer_settings' | translate }}</strong>
</h5>
<div class="cui__utils__line" style="margin-top: 25px"></div>
<div class="cui__sidebar__type">
	<div class="cui__sidebar__type__title">
		<span>Emulation</span>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.override' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.overrideHardwareStatus"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.TouchScreen' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateTouchScreen"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.ButtonDevice' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateButtonDevice"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.TappingPen' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateTappingPen"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.ExternalAudiometry' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateExternalAudiometry"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.SoundDevice' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateSoundDevice"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>

<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.Audiometry_Sh_HDA_300__Sb_X_G1__Th_PS_TPY_2003_KBB' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateAudiometry_Sh_HDA_300__Sb_X_G1__Th_PS_TPY_2003_KBB"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.Audiometry_bd_DT_770_PRO_32__Sb_X_G1' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateAudiometry_bd_DT_770_PRO_32__Sb_X_G1"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.ExternalBicycleErgometer' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateExternalBicycleErgometer"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
<div class="cui__sidebar__item">
	<div class="cui__sidebar__label">{{'device.TestHardware' | translate }}</div>
	<div class="cui__sidebar__container">
		<nz-switch
				[(ngModel)]="hardwareConfig.emulateTestHardware"
				(ngModelChange)="changeSetting()">
		</nz-switch>
	</div>
</div>
